import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EFConnectableSide, FFlowModule } from '@foblex/flow';
import { ViewPort } from '../../models';

@Component({
  selector: 'iot-platform-ui-flow-input',
  imports: [FFlowModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      data-test="iot-platform-ui-flow-input"
      fConnector
      fConnectorType="target"
      [fConnectorMultiple]="!!input()?.multiple"
      [fConnectorId]="input().id"
      [fConnectorConnectableSide]="input()?.position ?? EFConnectableSide.LEFT"
      class="{{ input()?.position ?? EFConnectableSide.LEFT }} {{ input()?.cssClassName }}"
    ></div>
  `
})
export class FlowInputComponent {
  input = input.required<ViewPort>();
  protected readonly EFConnectableSide = EFConnectableSide;
}
